export class LambdaTrigger {
    id: string = "";
    deviceId: string = "";
    labelType: number = 0;
    lambdaUrl: string = "";
    isOverriding: boolean = false;

    constructor(init?:Partial<LambdaTrigger>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
    }
}
